import React from "react";
import { FaqAccordionGroupProps } from "../../components/FaqAccordionGroup/FaqAccordionGroup";
import { GreyCard, GreyCardProps } from "../../components/GreyCard";
import { List } from "../../components/List";
import { Paragraph, ParagraphProps } from "../../components/Paragraph";
import { ProcessSteps, ProcessStepsProps } from "../../components/ProcessSteps";
import { SeoHeaderProps } from "../../components/SeoHeader";
import { ServiceCataloguePageWrapper } from "../../components/ServiceCataloguePageWrapper";
import { GenericListProps } from "../../types/GenericListType";

export interface UpgradesDowngradesPageProps {
  seo?: SeoHeaderProps;
  pageTitle: string;
  paragraphs?: ParagraphProps[];
  lists?: GenericListProps[];
  processes?: ProcessStepsProps[];
  wantToReport?: GreyCardProps;
  faqs?: FaqAccordionGroupProps;
}

export const UpgradesDowngradesPage: React.FC<UpgradesDowngradesPageProps> = ({
  seo,
  pageTitle,
  paragraphs,
  lists,
  processes,
  wantToReport,
  faqs,
}) => {
  return (
    <ServiceCataloguePageWrapper seo={seo} title={pageTitle} faqs={faqs}>
      {paragraphs && paragraphs[0] && <Paragraph {...paragraphs[0]} />}
      {paragraphs && paragraphs[1] && <Paragraph {...paragraphs[1]} />}
      {paragraphs && paragraphs[2] && <Paragraph {...paragraphs[2]} />}
      {lists && lists[0] && <List {...lists[0]} />}
      {paragraphs && paragraphs[3] && <Paragraph {...paragraphs[3]} />}
      {processes && processes[0] && <ProcessSteps {...processes[0]} />}
      {processes && processes[1] && <ProcessSteps {...processes[1]} />}
      {lists && lists[1] && <List {...lists[1]} />}
      {wantToReport && <GreyCard {...wantToReport} />}
    </ServiceCataloguePageWrapper>
  );
};
